import React from 'react';
import styled from '@emotion/styled';
import { color_shades_dark, color_shades_darkest, dark_grey_blue, silver_four } from '../../constants/colors';
import Button from '../general/Button';
import Switch from './Switch';
import { useForm } from 'react-hook-form';
import TextField from './TextField';
import TooltipWrapper from '../general/TooltipWrapper';

const deleteIcon = require('../../content/images/bin-2.svg');
const duplicateIcon = require('../../content/images/response-duplicate.svg');
const arrowIcon = require('../../content/images/arrow-circle-right-2.svg');

interface TextFieldProps {
    onDelete?: () => void
    onCopy?: () => void
    onSelect?: () => void
    canCopy?: boolean
    canDelete?: boolean
    canSelect?: boolean
    deletePosition?: IconPosition
    titleText?: string,
    editableTitle?: boolean
    titlePlaceholder?: string
    selectCount?: number
    onChangeTitle?: (newTitle: string) => void
    onTitleBlur?: () => void
}

const TextFieldSubtitle: React.FC<TextFieldProps> = ({ selectCount, titleText, canDelete, canCopy, deletePosition, canSelect, editableTitle, titlePlaceholder, onTitleBlur, onDelete, onSelect, onCopy, onChangeTitle }) => {
    return (
        <>
            <TitleContainer>
                <TitleLineBefore />
                {!editableTitle ?
                    <TitleText>{titleText}</TitleText>
                    :
                    <StyledTextField type="text" placeholder={titlePlaceholder} value={titleText} onBlur={(e) => onTitleBlur()} onChange={(e) => onChangeTitle(e.target.value)} />}
                <TitleLineAfter />
                <TitleIconContainer>
                    {canDelete && (deletePosition == undefined || deletePosition == "top") ?
                        <Button type="button" onClick={onDelete} themes={["medium-icon"]} icon={deleteIcon} />
                        :
                        null}
                    {canCopy && <Button type="button" onClick={onCopy} themes={["medium-icon"]} icon={duplicateIcon} />}
                    {canSelect ?                         
                        (selectCount && selectCount > 1) ?
                            <TooltipWrapper place="top" text={`Response used in ${selectCount} places`}>
                                <StyledCount onClick={onSelect}>{selectCount}</StyledCount>
                            </TooltipWrapper> :
                            <TooltipWrapper place="top" text={`Use existing named response`}>
                                <StyledArrow type="button" onClick={onSelect} themes={["medium-icon"]} icon={arrowIcon} />
                            </TooltipWrapper> :
                        <></>}
                </TitleIconContainer>
            </TitleContainer>
        </>
    );
};

type IconPosition = "top" | "right";

const StyledArrow = styled(Button)`    
    transform: rotate(90deg);
    margin-top: 8px;
`;

const StyledCount = styled.div`
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: ${color_shades_darkest};
    color: white;
    text-align: center;
    font-size: 12px;
    padding-top: 4px;
    cursor: pointer;
`;
const StyledTextField = styled.input`
    height: 30px;
    margin-left: 8px;
    border: 1px solid ${silver_four};
    color: ${dark_grey_blue};
    border-radius: 4px;
    padding-left: 8px;
`;
const TitleContainer = styled.div`
    height: 20px;
    display: flex;
    align-items: center;
    margin: 12px 0;
`
const TitleText = styled.h4`
    font-weight: 400;
    size: 16px;
    line-height: 24px;
    color: ${color_shades_darkest};
    padding: 0 8px;
`
const TitleLineBefore = styled.div`
    border-bottom: 1px solid ${silver_four};
    width: 8px;
`
const TitleLineAfter = styled.div`
    border-bottom: 1px solid ${silver_four};
    flex-grow: 1;
    margin-left: 8px;
`
const TitleIconContainer = styled.div`
    display: flex;
    align-items: center;
`

export default TextFieldSubtitle;